import { Modal, Button } from "@renderbus/ui";
import { ModalProps } from "antd";
import { useTranslation } from "react-i18next";

export function MaxSubaccountModal({
  open,
  modalProps,
}: {
  open: boolean;
  modalProps: ModalProps;
}) {
  const { t } = useTranslation("center");
  const prompts = [
    t("user_com_childManage_add_prompt_0"),
    t("user_com_childManage_add_prompt_1"),
    t("user_com_childManage_add_prompt_2"),
  ];

  return (
    <Modal
      title={t("common_store_global_dialog_default_title")}
      open={open}
      {...modalProps}
      children={
        <div style={{ color: "#BFC2C3" }}>
          <p>{prompts[0]}</p>
          <p>{prompts[1]}</p>
          <p>{prompts[2]}</p>
        </div>
      }
      footer={[
        <Button
          key="submit"
          type="primary"
          onClick={(e: any) => modalProps.onCancel?.(e)}
        >
          {t("dialog_action_confirm")}
        </Button>,
      ]}
    />
  );
}
